import { Component, input, computed } from '@angular/core';

@Component({
  selector: 'app-text',
  standalone: true,
  template: `<ng-content></ng-content>`,
  styleUrl: './text.component.scss',
  host: {
    '[attr.size]': 'size()',
    '[attr.weight]': 'weight()',
    '[attr.font]': 'font()', 
    '[style.color]': 'colorValue()'
  }
})
export class TextComponent {
  size = input<'xxxs' | 'xxs' |'xs' | 'pageText' | 'special' | 'reserve-add' | 'specialS' | 'package-tag'| 'special2' | 'special3' | 'specialL' | 'extra'|'extra2' | 'editProfile' | 'editName' | 'editFile' | 'reportTitle' | 'category-text' | 'report-download' | 'reportItem' | 'specialM' | 'legal' | 's' | 'm' | 'l' | 'xl' | 'xxl'>('m');
  weight = input<'s' | 'm' | 'l' | 'xl'>('s');
  
  // 字體預設為中文
  font = input<'zh' | 'en'>('zh');

  color = input<string>('gray-800');
  colorValue = computed(() => `var(--${this.color()})`);
}